import React from "react";
import { getInitials } from "../../utilities/helpers";
import { getCardColor2 } from "../../../../../helpers/helpers";
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import PauseIcon from "@mui/icons-material/Pause";
import ShiftDropDrawer from "../../shared/shiftswaps/ShiftDropDrawer";
import ShiftNoteInline from "../../shared/shiftswaps/ShiftNoteInline";
import { get_t_str } from "../../../../../helpers/helpers";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Lightbox } from "react-modal-image";

// HEIC/HEIF are accepted for upload but the backend re-encodes them to JPEG
// (browsers other than Safari can't render them); until that runs they show
// as a generic file rather than a broken image.
const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "svg"];

function EmployeeShiftCardToday(props) {
  const initialsArray = props.alsoWorking?.map((v, i) =>
    v.name === "undefined undefined" ? "O" : getInitials(v.name)
  );

  const [lightboxImage, setLightboxImage] = React.useState(null);
  // The whole card opens the shift drawer, so attachment clicks must stop
  // propagation. Images open in a lightbox; other files open in a new tab.
  const openAttachment = (e, file) => {
    e.stopPropagation();
    if (!file.presigned_url) return;
    if (IMAGE_EXTENSIONS.includes((file.extension || "").toLowerCase())) {
      setLightboxImage(file.presigned_url);
    } else {
      window.open(file.presigned_url, "_blank", "noopener,noreferrer");
    }
  };

  function handleAddToPoolPress(note) {
    props.drop_shift(props.shift.id, null, note);
  }

  const shiftCardColor = getCardColor2(
    props.roleId?.id,
    props.roleNames,
    false
  );


  const shiftInfo = props.shift

  let badgeText = "";
  if (shiftInfo?.badge === "is_pending_drop_by_user") {
    badgeText = "Drop Requested";
  } else if (
    shiftInfo?.badge === "is_trade_by_user_pending_employee_response"
  ) {
    badgeText = "Offered Trade";
  } else if (shiftInfo?.badge === "is_trade_by_user_pending_manager_response") {
    badgeText = "Offered Trade";
  } else if (shiftInfo?.badge === "is_trade_to_user_pending_self_response") {
    badgeText = "";
  } else if (shiftInfo?.badge === "is_trade_to_user_pending_manager_response") {
    badgeText = "";
  } else if (shiftInfo?.badge === "is_pending_pickup_by_user") {
    badgeText = "";
  } else {
    badgeText = "";
  }

  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <>
      {lightboxImage && (
        <div className="absolute w-screen h-screen z-50">
          <Lightbox
            small={lightboxImage}
            medium={lightboxImage}
            hideDownload={true}
            hideZoom={true}
            onClose={() => setLightboxImage(null)}
          />
        </div>
      )}
      <div
        className="w-full rounded-xl bg-violet-50 border border-violet-200 hover:bg-violet-100 px-5 py-4 cursor-pointer relative transition-colors"
        onClick={toggleDrawer(true)}
      >
        {/* Avatars anchor to this wrapper so they never cover the note below */}
        <div className="relative">
          <p className="text-violet-600 text-xs font-semibold">Your shift</p>
          <p className="text-slate-900 font-bold text-lg mt-0.5">
            {props.shiftStartNumber}{props.shiftStartLetters?.toLowerCase() || ""} - {props.shiftEndNumber}{props.shiftEndLetters?.toLowerCase() || ""}
          </p>
          <p className="text-sm text-slate-500 mt-0.5">
            {props.station
              ? props.station
              : props.role
              ? props.role
              : props.roleType}{" "}
            &mdash; {props.location}
          </p>
          {props.break && (
            <div className="mt-1.5 flex items-center text-slate-500 text-xs">
              <PauseIcon sx={{ fontSize: 14, color: "#94a3b8" }} className="mr-1" />
              <span>{props.break}</span>
            </div>
          )}
          {props.shift?.paid_break_summary && (
            <div className="mt-1 flex items-center text-slate-500 text-xs">
              <BackHandOutlinedIcon sx={{ fontSize: 14, color: "#94a3b8" }} className="mr-1" />
              <span>{props.shift.paid_break_summary}</span>
            </div>
          )}
          {initialsArray?.length > 0 && (
            <div className="absolute bottom-0 right-0 flex flex-row items-center">
              {initialsArray.slice(0, 4).map((initials, i) => (
                <div
                  key={i}
                  className={`w-7 h-7 ${getCardColor2(
                    props.alsoWorking?.[i]?.role_id?.id,
                    props.roleNames,
                    false,
                    false
                  )} border-2 border-violet-50 rounded-full flex items-center justify-center -mr-1.5`}
                  style={{ zIndex: 10 - i }}
                >
                  <p className="text-white text-[9px]">{initials}</p>
                </div>
              ))}
              {initialsArray.length > 4 && (
                <p className="text-xs text-slate-500 ml-2">
                  +{initialsArray.length - 4}
                </p>
              )}
            </div>
          )}
        </div>
        <ShiftNoteInline note={props.note} />
      </div>
      {props.dailyEvents?.length > 0 &&
        <div className="w-full mt-3">
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Notes</p>
          {props.dailyEvents.map((event, index) => (
            <div key={index} className="mt-1.5 rounded-xl bg-slate-50 border border-slate-100 px-3 py-2.5">
              <p className="text-sm font-semibold text-slate-900">{event.title}</p>
              {event.description && (
                <p className="text-xs text-slate-500 mt-0.5">{event.description}</p>
              )}
              {event.start_time && (
                <p className="text-xs text-violet-600 mt-0.5">
                  {get_t_str(event.start_time)}{event.end_time && ` - ${get_t_str(event.end_time)}`}
                </p>
              )}
              {event.attachments?.length > 0 && (
                <div className="mt-2 space-y-1.5">
                  {event.attachments.map((file) => {
                    const isImg = IMAGE_EXTENSIONS.includes((file.extension || "").toLowerCase());
                    return (
                      <button
                        key={file.uuid}
                        onClick={(e) => openAttachment(e, file)}
                        className="flex items-center gap-1.5 text-xs text-slate-600 hover:text-violet-700 w-full text-left"
                      >
                        {isImg ? (
                          <img
                            src={file.presigned_url}
                            alt={file.displayName || file.name}
                            className="w-8 h-8 rounded object-cover shrink-0"
                          />
                        ) : (
                          <InsertDriveFileIcon sx={{ fontSize: 14, color: "#94a3b8" }} />
                        )}
                        <span className="truncate">{file.displayName || file.name}</span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      }
      <ShiftDropDrawer
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        shiftInfo={shiftInfo}
        firstName={props.firstName}
        lastName={props.lastName}
        badgeText={badgeText}
        date={props.date}
        isDateInPast={props.isDateInPast}
        shiftStartNumber={props.shiftStartNumber}
        shiftStartLetters={props.shiftStartLetters}
        shiftEndNumber={props.shiftEndNumber}
        shiftEndLetters={props.shiftEndLetters}
        role={props.role}
        station={props.station}
        roleType={props.roleType}
        break={props.break}
        location={props.location}
        handleAddToPoolPress={handleAddToPoolPress}
        drop_shift={props.drop_shift}
        trade_shift={props.trade_shift}
        rescind_drop_shift={props.rescind_drop_shift}
        rescind_trade_shift={props.rescind_trade_shift}
        notMyUpcomingShifts={props.notMyUpcomingShifts}
        shiftCardColor={shiftCardColor}
        roleNames={props.roleNames}
        note={props.note}
        alsoWorking={props.alsoWorking}
      />
    </>
  );
}

export default EmployeeShiftCardToday;
